import getTcfConsent from './tcfv2';
import amaLog from '../helpers/log';
import { timeFor } from '../helpers/time';
import { hasTcfConsent } from './tcfv2';

const getConsent = async (): Promise<boolean | undefined> => {

  try {
    amaLog('Get tcf consent ...');

    const { tcData } = await getTcfConsent();

    amaLog(`Got tcf data consent ${timeFor("getTcfConsent")} `, tcData);

    const hasConsent = hasTcfConsent(tcData);

    amaLog(`hasConsent: ${hasConsent}`);

    return hasConsent;
  } catch (e) {
    console.error('Unable to retrieve tcf consent');
  }
};

export default getConsent;
